import React from 'react'

import { StaticQuery, graphql } from 'gatsby'
import { NonStretchedImage } from "actl"


export default function Image(props){
    return (<StaticQuery
        query={graphql`
            query {
                aws: file(relativePath: { eq: "hamilton-example-frame.jpg" }) {
                    childImageSharp {
                        fluid(maxWidth: 700) {
                        ...GatsbyImageSharpFluid
                        presentationWidth
                        }
                    }
                }
            }
        `}
        render= {data => <NonStretchedImage {...data.aws.childImageSharp} {...props}/>}
    />)
}